import { render, staticRenderFns } from "./SelectShippingNew.vue?vue&type=template&id=50044618&"
import script from "./SelectShippingNew.vue?vue&type=script&lang=js&"
export * from "./SelectShippingNew.vue?vue&type=script&lang=js&"
import style0 from "./SelectShippingNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports